import { isEqual } from 'lodash';
import * as i0 from "@angular/core";
var NodeIndexService = /** @class */ (function () {
    function NodeIndexService() {
        this.traversal = [];
    }
    NodeIndexService.prototype.getNodeIdx = function (node) {
        var type = this.getNodeType(node);
        if (type) {
            return node[this.getNodeType(node)].node_idx;
        }
        else {
            return '';
        }
    };
    NodeIndexService.prototype.getBranchIdx = function (node) {
        var type = this.getNodeType(node);
        if (type) {
            return node[this.getNodeType(node)].branch_idx;
        }
        else {
            return '';
        }
    };
    NodeIndexService.prototype.getNodeType = function (node) {
        if (typeof (node) === 'object') {
            return Object.keys(node)[0];
        }
        else {
            return null;
        }
    };
    NodeIndexService.prototype.getNodeBody = function (node) {
        var type = this.getNodeType(node);
        if (type) {
            return node[type];
        }
        else {
            return {};
        }
    };
    NodeIndexService.prototype.getNodePath = function (node, searchNode, path) {
        if (node === searchNode) {
            return (path || '') + this.getBranchIdx(node) + this.getNodeIdx(node);
        }
        else {
            path = (path || '') + this.getBranchIdx(node) + this.getNodeIdx(node);
            var retPath = null;
            var body = this.getNodeBody(node);
            switch (this.getNodeType(node)) {
                case 'ab_exp_node':
                    for (var _i = 0, _a = body.default_statements; _i < _a.length; _i++) {
                        var statement = _a[_i];
                        retPath = this.getNodePath(statement, searchNode, path);
                        if (retPath) {
                            return retPath;
                        }
                    }
                    for (var _b = 0, _c = body.split; _b < _c.length; _b++) {
                        var split = _c[_b];
                        for (var _d = 0, _e = split.statements; _d < _e.length; _d++) {
                            var statement = _e[_d];
                            retPath = this.getNodePath(statement, searchNode, path);
                            if (retPath) {
                                return retPath;
                            }
                        }
                    }
                    break;
                case 'rollout_node':
                    for (var _f = 0, _g = body.default_statements; _f < _g.length; _f++) {
                        var statement = _g[_f];
                        retPath = this.getNodePath(statement, searchNode, path);
                        if (retPath) {
                            return retPath;
                        }
                    }
                    for (var _h = 0, _j = body.statements; _h < _j.length; _h++) {
                        var statement = _j[_h];
                        retPath = this.getNodePath(statement, searchNode, path);
                        if (retPath) {
                            return retPath;
                        }
                    }
                    break;
                case 'decision_node':
                    for (var _k = 0, _l = body.segments; _k < _l.length; _k++) {
                        var segment = _l[_k];
                        for (var _m = 0, _o = segment.statements; _m < _o.length; _m++) {
                            var statement = _o[_m];
                            retPath = this.getNodePath(statement, searchNode, path);
                            if (retPath) {
                                return retPath;
                            }
                        }
                    }
                    break;
                case 'action_node':
                    for (var _p = 0, _q = body.statements; _p < _q.length; _p++) {
                        var statement = _q[_p];
                        retPath = this.getNodePath(statement, searchNode, path);
                        if (retPath) {
                            return retPath;
                        }
                    }
                    break;
            }
            return retPath;
        }
    };
    NodeIndexService.prototype.doesNodeContainPrompt = function (node) {
        return !!node.exp_stack.filter(function (exp) { return exp.type === 'prompt'; }).length;
    };
    NodeIndexService.prototype.getExpStack = function (dtree, node, resultObj) {
        var _a;
        var nodeType = this.getNodeType(node);
        var body = this.getNodeBody(node);
        if (this.doesNodeContainPrompt(body)) {
            var expStack = body.exp_stack.filter(function (exp) { return exp.type === 'prompt' && exp.actions && exp.actions[0] && exp.actions[0].display_prompt && exp.actions[0].display_prompt.prompt_type !== 'invisible'; });
            (_a = resultObj.nudges).push.apply(_a, expStack);
            resultObj.wrapperNodes.push(node);
        }
        if (nodeType === 'leaf_node' && body.exp_stack && body.exp_stack.length === 0) {
            return resultObj;
        }
        else {
            switch (nodeType) {
                case 'ab_exp_node':
                    for (var _i = 0, _b = body.default_statements; _i < _b.length; _i++) {
                        var statement = _b[_i];
                        this.getExpStack(dtree, statement, resultObj);
                    }
                    for (var _c = 0, _d = body.split; _c < _d.length; _c++) {
                        var split = _d[_c];
                        for (var _e = 0, _f = split.statements; _e < _f.length; _e++) {
                            var statement = _f[_e];
                            this.getExpStack(dtree, statement, resultObj);
                        }
                    }
                    break;
                case 'rollout_node':
                    for (var _g = 0, _h = body.default_statements; _g < _h.length; _g++) {
                        var statement = _h[_g];
                        this.getExpStack(dtree, statement, resultObj);
                    }
                    for (var _j = 0, _k = body.statements; _j < _k.length; _j++) {
                        var statement = _k[_j];
                        this.getExpStack(dtree, statement, resultObj);
                    }
                    break;
                case 'decision_node':
                    for (var _l = 0, _m = body.segments; _l < _m.length; _l++) {
                        var segment = _m[_l];
                        for (var _o = 0, _p = segment.statements; _o < _p.length; _o++) {
                            var statement = _p[_o];
                            this.getExpStack(dtree, statement, resultObj);
                        }
                    }
                    break;
                case 'action_node':
                    for (var _q = 0, _r = body.statements; _q < _r.length; _q++) {
                        var statement = _r[_q];
                        this.getExpStack(dtree, statement, resultObj);
                    }
                    break;
            }
            return resultObj;
        }
    };
    NodeIndexService.prototype.getSearchableNodeDataWithType = function (node, searchNode, validateNudgeName, obj) {
        if (validateNudgeName === void 0) { validateNudgeName = false; }
        if (obj === void 0) { obj = {}; }
        var nodeType = this.getNodeType(node);
        var body = this.getNodeBody(node);
        if (body.node_idx === searchNode.node_idx && validateNudgeName && body.exp_stack && body.exp_stack.length) {
            if (body.exp_stack[0].title === searchNode.exp_stack[0].title) {
                obj['nodeWrapper'] = node;
                return obj;
            }
        }
        if (body.node_idx === searchNode.node_idx && isEqual(body, searchNode)) {
            obj['nodeWrapper'] = node;
            return obj;
        }
        else {
            switch (nodeType) {
                case 'ab_exp_node':
                    for (var _i = 0, _a = body.default_statements; _i < _a.length; _i++) {
                        var statement = _a[_i];
                        this.getSearchableNodeDataWithType(statement, searchNode, validateNudgeName, obj);
                        if (Object.keys(obj).length) {
                            return obj;
                        }
                    }
                    for (var _b = 0, _c = body.split; _b < _c.length; _b++) {
                        var split = _c[_b];
                        for (var _d = 0, _e = split.statements; _d < _e.length; _d++) {
                            var statement = _e[_d];
                            this.getSearchableNodeDataWithType(statement, searchNode, validateNudgeName, obj);
                            if (Object.keys(obj).length) {
                                return obj;
                            }
                        }
                    }
                    break;
                case 'rollout_node':
                    for (var _f = 0, _g = body.default_statements; _f < _g.length; _f++) {
                        var statement = _g[_f];
                        this.getSearchableNodeDataWithType(statement, searchNode, validateNudgeName, obj);
                        if (Object.keys(obj).length) {
                            return obj;
                        }
                    }
                    for (var _h = 0, _j = body.statements; _h < _j.length; _h++) {
                        var statement = _j[_h];
                        this.getSearchableNodeDataWithType(statement, searchNode, validateNudgeName, obj);
                        if (Object.keys(obj).length) {
                            return obj;
                        }
                    }
                    break;
                case 'decision_node':
                    for (var _k = 0, _l = body.segments; _k < _l.length; _k++) {
                        var segment = _l[_k];
                        for (var _m = 0, _o = segment.statements; _m < _o.length; _m++) {
                            var statement = _o[_m];
                            this.getSearchableNodeDataWithType(statement, searchNode, validateNudgeName, obj);
                            if (Object.keys(obj).length) {
                                return obj;
                            }
                        }
                    }
                    break;
                case 'action_node':
                    for (var _p = 0, _q = body.statements; _p < _q.length; _p++) {
                        var statement = _q[_p];
                        this.getSearchableNodeDataWithType(statement, searchNode, validateNudgeName, obj);
                        if (Object.keys(obj).length) {
                            return obj;
                        }
                    }
                    break;
            }
            return obj;
        }
    };
    NodeIndexService.prototype.nodeIdxInStatements = function (idx, statements) {
        return true;
    };
    NodeIndexService.prototype.getNextChildNodeId = function (node) {
        var nodeObj = this.getNodeBody(node);
        if (!(nodeObj && nodeObj.change_history && nodeObj.change_history.last_node_idx)) {
            return '0';
        }
        return this.generateNextNodeId(nodeObj.change_history.last_node_idx, node);
    };
    NodeIndexService.prototype.getNextNodeId = function (idx, parentNode) {
        var nodeObj = this.getNodeBody(parentNode);
        if (nodeObj && nodeObj.change_history && nodeObj.change_history.last_node_idx) {
            return this.generateNextNodeId(nodeObj.change_history.last_node_idx, parentNode);
        }
        else {
            return this.generateNextNodeId(idx, parentNode);
        }
    };
    NodeIndexService.prototype.getNextId = function (idx) {
        var inputSet = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ&'; // and ':' to identify root node.
        var lsb = idx[idx.length - 1];
        var retVal = '';
        // LSB is going to overflow
        if (lsb === '&') {
            // Is root node index
            if (idx[0] === ':') {
                retVal = ':' + '0'.repeat(idx.length + 1);
            }
            else {
                retVal = '0'.repeat(idx.length + 1);
            }
        }
        else {
            var k = idx.split('');
            k.pop();
            k.push(inputSet[inputSet.indexOf(lsb) + 1]);
            retVal = k.join('');
        }
        return retVal;
    };
    NodeIndexService.prototype.generateNextNodeId = function (idx, parentNode) {
        var retVal = this.getNextId(idx);
        var parentNodeType = this.getNodeType(parentNode);
        if (parentNode.change_history) {
            parentNode.change_history['last_node_idx'] = retVal;
        }
        else if (parentNode[parentNodeType] && parentNode[parentNodeType].change_history) {
            parentNode[parentNodeType].change_history['last_node_idx'] = retVal;
        }
        else {
            switch (parentNodeType) {
                case 'decision_node':
                case 'action_node':
                case 'ab_exp_node':
                case 'rollout_node':
                    parentNode[parentNodeType]['change_history'] = {
                        'last_node_idx': retVal
                    };
                    break;
                default:
                    parentNode['change_history'] = {
                        'last_node_idx': retVal
                    };
            }
        }
        return retVal;
    };
    NodeIndexService.prototype.generateNodeId = function (node, parentNode) {
        var idx = this.getNodeIdx(node);
        return idx;
    };
    // TREE TRAVERSAL METHODS FOR VERIFICATION AND QA //
    NodeIndexService.prototype.treeTraverser = function (root, nodeIds) {
        var _this = this;
        this.traversal = [];
        this.root = root;
        var traversalStr = '';
        var error = false;
        this.traverser(root);
        this.traversal.forEach(function (element, index) {
            if (nodeIds && nodeIds.length > 0) {
                if (nodeIds[index] === element) {
                    traversalStr += '<span style="color:green">' + element + '</span>';
                }
                else {
                    traversalStr += '<span style="color:red">' + element + '</span>';
                    error = true;
                }
            }
            else {
                traversalStr += '<span style="color:black">' + element + '</span>';
            }
            if (index !== _this.traversal.length - 1) {
                traversalStr += ',';
            }
        });
        if (error) {
            traversalStr += '<span style="color:red"><b> ERROR : BRANCH ID MISMATCH </b></span>';
            alert('ERROR : BRANCH ID MISMATCH IN TREE');
        }
        this.checkDuplicates(this.traversal);
        document.getElementById('innerHTML-injector').innerHTML = traversalStr;
    };
    NodeIndexService.prototype.checkDuplicates = function (arr) {
        var uniq = arr
            .map(function (name) {
            return { count: 1, name: name };
        })
            .reduce(function (a, b) {
            a[b.name] = (a[b.name] || 0) + b.count;
            return a;
        }, {});
        var duplicates = Object.keys(uniq).filter(function (a) { return uniq[a] > 1; });
        if (duplicates.length > 0) {
            alert('ERROR : DUPLICATE NODES FOUND IN TREE' + duplicates);
        }
        return duplicates.length;
    };
    NodeIndexService.prototype.validateExpStack = function (expStack, nodeId) {
        var expAcc = [];
        expStack.forEach(function (exp) {
            var idx = exp.node_idx;
            var lidx = exp.lidx;
            if (expAcc.indexOf(idx) >= 0) {
                alert('expStack has duplicate IDx : ' + nodeId + ':' + idx);
                console.log('Duplicate expStack Item: ', nodeId + ':' + idx, 'lidx:' + lidx);
            }
            expAcc.push(idx);
        });
    };
    NodeIndexService.prototype.traverser = function (node) {
        var _this = this;
        var nodeType = this.getNodeType(node);
        var stmts = [];
        switch (nodeType) {
            case 'ab_exp_node':
                stmts = stmts.concat(node[nodeType].default_statements);
                node[nodeType].split.forEach(function (element) {
                    stmts = stmts.concat(element.statements);
                });
                break;
            case 'decision_node':
                node[nodeType].segments.forEach(function (element) {
                    stmts = stmts.concat(element.statements);
                });
                break;
            case 'action_node':
                stmts = stmts.concat(node[nodeType].statements);
                break;
            case 'rollout_node':
                stmts = stmts.concat(node[nodeType].default_statements);
                stmts = stmts.concat(node[nodeType].statements);
                break;
            case 'leaf_node':
        }
        var nodePath = this.getNodePath(this.root, node, '');
        this.validateExpStack(node[nodeType].exp_stack, nodePath);
        this.traversal.push(nodePath);
        stmts.forEach(function (element) {
            _this.traverser(element);
        });
    };
    NodeIndexService.prototype.checkTheNodesPresent = function (node, checkList) {
        var nodeType = this.getNodeType(node);
        var body = this.getNodeBody(node);
        if (!checkList.nudges && this.doesNodeContainPrompt(body)) {
            checkList.nudges = true;
        }
        switch (nodeType) {
            case 'ab_exp_node':
                checkList.ab = true;
                for (var _i = 0, _a = body.default_statements; _i < _a.length; _i++) {
                    var statement = _a[_i];
                    this.checkTheNodesPresent(statement, checkList);
                }
                for (var _b = 0, _c = body.split; _b < _c.length; _b++) {
                    var split = _c[_b];
                    for (var _d = 0, _e = split.statements; _d < _e.length; _d++) {
                        var statement = _e[_d];
                        this.checkTheNodesPresent(statement, checkList);
                    }
                }
                break;
            case 'rollout_node':
                checkList.rollout = true;
                for (var _f = 0, _g = body.default_statements; _f < _g.length; _f++) {
                    var statement = _g[_f];
                    this.checkTheNodesPresent(statement, checkList);
                }
                for (var _h = 0, _j = body.statements; _h < _j.length; _h++) {
                    var statement = _j[_h];
                    this.checkTheNodesPresent(statement, checkList);
                }
                break;
            case 'decision_node':
                checkList.segment = true;
                for (var _k = 0, _l = body.segments; _k < _l.length; _k++) {
                    var segment = _l[_k];
                    for (var _m = 0, _o = segment.statements; _m < _o.length; _m++) {
                        var statement = _o[_m];
                        this.checkTheNodesPresent(statement, checkList);
                    }
                }
                break;
            case 'action_node':
                for (var _p = 0, _q = body.statements; _p < _q.length; _p++) {
                    var statement = _q[_p];
                    this.checkTheNodesPresent(statement, checkList);
                }
                break;
        }
        return checkList;
    };
    NodeIndexService.prototype.doesTreeContainAllUserNode = function (node) {
        var nodeType = this.getNodeType(node);
        var nodeBody = this.getNodeBody(node);
        if (nodeType === 'leaf_node') {
            if (nodeBody.exp_stack.length) {
                return true;
            }
            return false;
        }
        if (nodeType !== 'decision_node') {
            return true;
        }
        return false;
    };
    NodeIndexService.prototype.getAllModuleListFromDtree = function (node, expStackObj) {
        var nodeType = this.getNodeType(node);
        var body = this.getNodeBody(node);
        if (body.exp_stack && body.exp_stack.length) {
            this.pushExpModuleIdToObj(body, expStackObj);
        }
        switch (nodeType) {
            case 'ab_exp_node':
                for (var _i = 0, _a = body.default_statements; _i < _a.length; _i++) {
                    var statement = _a[_i];
                    this.getAllModuleListFromDtree(statement, expStackObj);
                }
                for (var _b = 0, _c = body.split; _b < _c.length; _b++) {
                    var split = _c[_b];
                    for (var _d = 0, _e = split.statements; _d < _e.length; _d++) {
                        var statement = _e[_d];
                        this.getAllModuleListFromDtree(statement, expStackObj);
                    }
                }
                break;
            case 'rollout_node':
                for (var _f = 0, _g = body.default_statements; _f < _g.length; _f++) {
                    var statement = _g[_f];
                    this.getAllModuleListFromDtree(statement, expStackObj);
                }
                for (var _h = 0, _j = body.statements; _h < _j.length; _h++) {
                    var statement = _j[_h];
                    this.getAllModuleListFromDtree(statement, expStackObj);
                }
                break;
            case 'decision_node':
                for (var _k = 0, _l = body.segments; _k < _l.length; _k++) {
                    var segment = _l[_k];
                    for (var _m = 0, _o = segment.statements; _m < _o.length; _m++) {
                        var statement = _o[_m];
                        this.getAllModuleListFromDtree(statement, expStackObj);
                    }
                }
                break;
            case 'action_node':
                for (var _p = 0, _q = body.statements; _p < _q.length; _p++) {
                    var statement = _q[_p];
                    this.getAllModuleListFromDtree(statement, expStackObj);
                }
                break;
        }
        return expStackObj;
    };
    NodeIndexService.prototype.pushExpModuleIdToObj = function (body, obj) {
        var experienceNode = body.exp_stack.filter(function (node) { return node.type === 'experience'; });
        experienceNode.forEach(function (node) { return obj[node.module_ids[0]] = 1; });
    };
    NodeIndexService.prototype.getAllSegmentIdFromSegment = function (node, segmentIds) {
        var nodeType = this.getNodeType(node);
        var body = this.getNodeBody(node);
        switch (nodeType) {
            case 'ab_exp_node':
                for (var _i = 0, _a = body.default_statements; _i < _a.length; _i++) {
                    var statement = _a[_i];
                    this.getAllSegmentIdFromSegment(statement, segmentIds);
                }
                for (var _b = 0, _c = body.split; _b < _c.length; _b++) {
                    var split = _c[_b];
                    for (var _d = 0, _e = split.statements; _d < _e.length; _d++) {
                        var statement = _e[_d];
                        this.getAllSegmentIdFromSegment(statement, segmentIds);
                    }
                }
                break;
            case 'rollout_node':
                for (var _f = 0, _g = body.default_statements; _f < _g.length; _f++) {
                    var statement = _g[_f];
                    this.getAllSegmentIdFromSegment(statement, segmentIds);
                }
                for (var _h = 0, _j = body.statements; _h < _j.length; _h++) {
                    var statement = _j[_h];
                    this.getAllSegmentIdFromSegment(statement, segmentIds);
                }
                break;
            case 'decision_node':
                if (body.segments[0].segment.id) {
                    segmentIds.push(body.segments[0].segment.id);
                }
                for (var _k = 0, _l = body.segments; _k < _l.length; _k++) {
                    var segment = _l[_k];
                    for (var _m = 0, _o = segment.statements; _m < _o.length; _m++) {
                        var statement = _o[_m];
                        this.getAllSegmentIdFromSegment(statement, segmentIds);
                    }
                }
                break;
            case 'action_node':
                for (var _p = 0, _q = body.statements; _p < _q.length; _p++) {
                    var statement = _q[_p];
                    this.getAllSegmentIdFromSegment(statement, segmentIds);
                }
                break;
        }
        return segmentIds;
    };
    NodeIndexService.prototype.getAllStopEventList = function (node, eventList) {
        var nodeType = this.getNodeType(node);
        var body = this.getNodeBody(node);
        if (body.exp_stack && body.exp_stack.length) {
            this.pushStopEventFromExp(body, eventList);
        }
        switch (nodeType) {
            case 'ab_exp_node':
                for (var _i = 0, _a = body.default_statements; _i < _a.length; _i++) {
                    var statement = _a[_i];
                    this.getAllStopEventList(statement, eventList);
                }
                for (var _b = 0, _c = body.split; _b < _c.length; _b++) {
                    var split = _c[_b];
                    for (var _d = 0, _e = split.statements; _d < _e.length; _d++) {
                        var statement = _e[_d];
                        this.getAllStopEventList(statement, eventList);
                    }
                }
                break;
            case 'rollout_node':
                for (var _f = 0, _g = body.default_statements; _f < _g.length; _f++) {
                    var statement = _g[_f];
                    this.getAllStopEventList(statement, eventList);
                }
                for (var _h = 0, _j = body.statements; _h < _j.length; _h++) {
                    var statement = _j[_h];
                    this.getAllStopEventList(statement, eventList);
                }
                break;
            case 'decision_node':
                for (var _k = 0, _l = body.segments; _k < _l.length; _k++) {
                    var segment = _l[_k];
                    for (var _m = 0, _o = segment.statements; _m < _o.length; _m++) {
                        var statement = _o[_m];
                        this.getAllStopEventList(statement, eventList);
                    }
                }
                break;
            case 'action_node':
                for (var _p = 0, _q = body.statements; _p < _q.length; _p++) {
                    var statement = _q[_p];
                    this.getAllStopEventList(statement, eventList);
                }
                break;
        }
        return eventList;
    };
    NodeIndexService.prototype.pushStopEventFromExp = function (body, list) {
        body.exp_stack.forEach(function (expNode) {
            if (expNode.type === 'prompt') {
                var stopCondition = expNode.actions[0].display_prompt.stop[0];
                if (stopCondition && stopCondition.type === 'event') {
                    list.push(stopCondition);
                }
            }
        });
    };
    NodeIndexService.prototype.getABNodeFromDtree = function (node, arr) {
        var nodeType = this.getNodeType(node);
        var body = this.getNodeBody(node);
        switch (nodeType) {
            case 'ab_exp_node':
                arr.push(node);
                for (var _i = 0, _a = body.default_statements; _i < _a.length; _i++) {
                    var statement = _a[_i];
                    this.getABNodeFromDtree(statement, arr);
                }
                for (var _b = 0, _c = body.split; _b < _c.length; _b++) {
                    var split = _c[_b];
                    for (var _d = 0, _e = split.statements; _d < _e.length; _d++) {
                        var statement = _e[_d];
                        this.getABNodeFromDtree(statement, arr);
                    }
                }
                break;
            case 'rollout_node':
                for (var _f = 0, _g = body.default_statements; _f < _g.length; _f++) {
                    var statement = _g[_f];
                    this.getABNodeFromDtree(statement, arr);
                }
                for (var _h = 0, _j = body.statements; _h < _j.length; _h++) {
                    var statement = _j[_h];
                    this.getABNodeFromDtree(statement, arr);
                }
                break;
            case 'decision_node':
                for (var _k = 0, _l = body.segments; _k < _l.length; _k++) {
                    var segment = _l[_k];
                    for (var _m = 0, _o = segment.statements; _m < _o.length; _m++) {
                        var statement = _o[_m];
                        this.getABNodeFromDtree(statement, arr);
                    }
                }
                break;
            case 'action_node':
                for (var _p = 0, _q = body.statements; _p < _q.length; _p++) {
                    var statement = _q[_p];
                    this.getABNodeFromDtree(statement, arr);
                }
                break;
        }
        return arr;
    };
    NodeIndexService.prototype.getTheParentOfNode = function (st, node, sts, parent) {
        var stType = this.getNodeType(st);
        var stBody = this.getNodeBody(st);
        if (node.node_idx === stBody.node_idx) {
            parent.p = sts;
            return;
        }
        switch (stType) {
            case 'ab_exp_node':
                for (var _i = 0, _a = stBody.default_statements; _i < _a.length; _i++) {
                    var statement = _a[_i];
                    this.getTheParentOfNode(statement, node, stBody.default_statements, parent);
                }
                for (var _b = 0, _c = stBody.split; _b < _c.length; _b++) {
                    var split = _c[_b];
                    for (var _d = 0, _e = split.statements; _d < _e.length; _d++) {
                        var statement = _e[_d];
                        this.getTheParentOfNode(statement, node, split.statements, parent);
                    }
                }
                break;
            case 'rollout_node':
                for (var _f = 0, _g = stBody.default_statements; _f < _g.length; _f++) {
                    var statement = _g[_f];
                    this.getTheParentOfNode(statement, node, stBody.default_statements, parent);
                }
                for (var _h = 0, _j = stBody.statements; _h < _j.length; _h++) {
                    var statement = _j[_h];
                    this.getTheParentOfNode(statement, node, stBody.statements, parent);
                }
                break;
            case 'decision_node':
                for (var _k = 0, _l = stBody.segments; _k < _l.length; _k++) {
                    var segment = _l[_k];
                    for (var _m = 0, _o = segment.statements; _m < _o.length; _m++) {
                        var statement = _o[_m];
                        this.getTheParentOfNode(statement, node, segment.statements, parent);
                    }
                }
                break;
            case 'action_node':
                for (var _p = 0, _q = stBody.statements; _p < _q.length; _p++) {
                    var statement = _q[_p];
                    this.getTheParentOfNode(statement, node, stBody.statements, parent);
                }
                break;
        }
    };
    NodeIndexService.ngInjectableDef = i0.defineInjectable({ factory: function NodeIndexService_Factory() { return new NodeIndexService(); }, token: NodeIndexService, providedIn: "root" });
    return NodeIndexService;
}());
export { NodeIndexService };
